module.exports = __webpack_public_path__ + "static/media/3_Spisak akcioneri_2015-20150626.514f43c1.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/informationInversors/2015/3_Spisak akcioneri_2015-20150626.pdf
// module id = 183
// module chunks = 0